var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search_content"},[_c('div',{staticClass:"hot_search"},[(_vm.$store.state.hotLisat.length > 0)?_c('p',{staticClass:"title"},[_vm._v("热门搜索")]):_vm._e(),_c('ul',_vm._l((_vm.$store.state.hotLisat),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.$router.push({
        path: '/gameDetails',
        query: {
          id: item.gameId,
        },
      })}}},[_vm._v(_vm._s(item.searchName))])}),0)]),_c('div',{staticClass:"search_result"},[_c('p',{staticClass:"title"},[_vm._v("搜索结果")]),(_vm.$store.state.searList.length > 0)?_c('ul',_vm._l((_vm.$store.state.searList),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.$router.push({
        path: '/gameDetails',
        query: {
          id: item.resultID,
        },
      })}}},[_vm._v(" "+_vm._s(item.searchResult)+" ")])}),0):_c('p',[_vm._v("暂无搜索结果")])])])}
var staticRenderFns = []

export { render, staticRenderFns }